
import VRangeCalculator from '~/components/calc-block/VRangeCalculator.vue';
export default {
  name: 'CalcBlockControls',
  components: {
    VRangeCalculator,
  },
  props: {
    currentPaymentInfo: {
      tpye: Object,
      default: () => ({}),
    },
    initPaymentInfo: {
      type: Object,
      default: () => ({}),
    },
    // Для передачи со страницы товара
    productPrice: {
      type: Number,
      default: null,
      required: false,
    }
  },
  emits: [
    'changeCurrentPaymentInfo',
  ],

  computed: {
    stringMessage: function () {
      if (!this.currentPaymentInfo) {
        return;
      }
      return `Заявка на ипотеку, на сумму: ${this.$numberFormat(this.currentPaymentInfo.cost)} руб
	      сроком на ${this.currentPaymentInfo.term} лет,
	      с процентной ставкой ${this.currentPaymentInfo.interestRate}%,
	      и первым взносом в размере ${this.$numberFormat(this.currentPaymentInfo.firstPay)}`;
    },
    paramsForSendIpotekaCall: function () {
      if (!this.currentPaymentInfo) {
        return {};
      }
      const params = {
        price: Number(this.productPrice),
        amount: Number(this.currentPaymentInfo.cost),
        initialPayment: this.currentPaymentInfo.firstPay,
        interest: Number(Number(this.currentPaymentInfo.interestRate) / 100).toFixed(4),
        years: Number(this.currentPaymentInfo.term),
      }
      return params;
    },
  },

  methods: {
    onChangeCurrentPaymentInfo: function (options) {
      const { slug, value } = options;
      this.$emit('changeCurrentPaymentInfo', { slug, value });
    },
    openPopupCalc: function () {
      this.$store.commit('pop-up-ipoteka-call/setOpen', {
        open: true,
        settings: {
          title: `${this.stringMessage}`,
          params: this.paramsForSendIpotekaCall,
          //reachGoal: 'octavut_saavku_chapka', // если появится цель, то добавить
        },
      });
    }
  }
}
